module.exports = __webpack_public_path__ + "static/media/spot.3bd4b6c0.svg";